import React from 'react';
import { clsx } from 'clsx';

interface PriceDisplayProps {
  amount: number;
  emphasize?: boolean;
  className?: string;
}

/**
 * Componente especializado para mostrar precios
 * Jerarquía visual principal en el módulo de ventas
 */
const PriceDisplay: React.FC<PriceDisplayProps> = ({ 
  amount, 
  emphasize = true,
  className = ''
}) => {
  return (
    <div className={clsx(
      'flex items-baseline',
      className
    )}>
      <span className="text-sm font-semibold text-gray-600 mr-1">$</span>
      <span 
        className={clsx(
          'transition-all duration-300',
          emphasize 
            ? 'text-3xl md:text-4xl font-black text-red-600' 
            : 'text-2xl font-bold text-gray-900'
        )}
      >
        {amount.toLocaleString('es-CO', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })}
      </span>
      <span className="text-sm font-medium text-gray-500 ml-1 hidden sm:inline">COP</span>
    </div>
  );
};

export default PriceDisplay;
